// ============= Imports =============
import { AuthContextProps } from '@/contexts/AuthContext';
import { tokenManager } from '@tw/tw-component-library';
import {
  UserAuditLog,
  UserAuditLogResponse,
} from './postAuditLog';

// ============= Constants =============
const BASE_URL = import.meta.env.VITE_BASE_CORE_URL;
const API_ENDPOINT = '/api/UserAuditLog/all';
const LITIUM_SCOPE = import.meta.env.VITE_LITIUM_CORE_SCOPE;

const HEADERS = {
  'Content-Type': 'application/json',
};

// ============= Types =============
export interface PostUserAuditLogAllProps {
  getAccessToken: AuthContextProps['getAccessToken'];
  body: UserAuditLog;
}

// ============= Utility Functions =============
const createHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
});

// ============= Main Function =============
export const postUserAuditLogAll = async ({
  getAccessToken,
  body,
}: PostUserAuditLogAllProps): Promise<UserAuditLogResponse> => {
  try {
    console.log('🔄 Posting all-user audit log...');

    const token = await getAccessToken([LITIUM_SCOPE]);
    if (!token) {
      throw new Error('Failed to acquire API token');
    }
    tokenManager.logTokenInfo(token, 'API');

    const url = `${BASE_URL}${API_ENDPOINT}`;
    const convertURI = encodeURI(url);
    console.log('🌐 Making request to:', convertURI);

    const response = await fetch(convertURI, {
      method: 'POST',
      headers: createHeaders(token),
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ All-user audit log posted successfully');
    return data;
  } catch (error) {
    console.error('🔴 Error posting all-user audit log:', error);
    throw error;
  }
};
